/**
 * Renders a minimal error screen inside `<app-root>` when runtime
 * configuration cannot be loaded. Bootstrap is aborted by the caller so the
 * Angular app never runs against an unknown environment.
 */
export function renderRuntimeConfigError(cause: unknown): void {
  const host = document.querySelector('app-root') ?? document.body;
  const message = cause instanceof Error ? cause.message : 'error desconocido';

  host.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      background: #f7f9fc;
      color: #1f2937;
    ">
      <div style="
        max-width: 480px;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 32px;
        box-shadow: 0 10px 25px -10px rgba(15, 23, 42, 0.15);
        text-align: center;
      ">
        <h1 style="margin: 0 0 12px; font-size: 22px;">No pudimos cargar la configuración</h1>
        <p style="margin: 0 0 16px; color: #4b5563;">
          La aplicación no puede iniciar porque falló la consulta a
          <code style="background:#f3f4f6;padding:2px 6px;border-radius:4px;">/api/config</code>.
        </p>
        <p style="margin: 0 0 24px; color: #6b7280; font-size: 13px;">
          Detalle técnico: <span style="color:#b91c1c;">${escapeHtml(message)}</span>
        </p>
        <button onclick="window.location.reload()" style="
          background: #2563eb;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
        ">Reintentar</button>
      </div>
    </div>
  `;
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
